module.exports = ".botones-opcionales{\n    display: flex;\n}"